import { Component, Input, Output, EventEmitter } from '@angular/core';
import {
  DesignerContextType,
  DesignerCachableOutput,
} from '../../types/designer-context-type';
import { CompleteDesignerContext } from '../main/completeContext';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { Router, ActivatedRoute } from '@angular/router';
import { CacheService } from 'app/infrastructure/services/cache.service';
import { SxInternalStateDesignerService } from '../../services/internal-state-designer-service';

@Component({
  selector: 'sx-page-modal',
  templateUrl: './page-modal.component.html',
})
export class SxPageModalComponent {
  // The name of the new page for the page modals
  NewPageName: string;
  // Designer Context
  @Input()
  designerContext: DesignerContextType;
  // Application Context
  @Input()
  completeContext: CompleteDesignerContext;

  @Output()
  saveDesigner: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private ngxSmartModalService: NgxSmartModalService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cacheService: CacheService,
    private internalState: SxInternalStateDesignerService
  ) {}

  // this is triggered to create a new flow page if needed
  createNewPage() {
    // by construction, this cant be null
    this.designerContext.selectedDesigner.attributes.find(
      (x) => x.name === this.internalState.getCurrentPropertyModal()
    ).value = this.NewPageName;

    // firts it saves
    this.saveDesigner.emit(false);

    // only remembers the last step
    this.cacheService.removeDesignerOutputs();
    const contx: DesignerCachableOutput = {
      storedContext: this.completeContext,
      storedSelectionId: this.designerContext.selectedDesigner.id,
      propertyName: this.internalState.getCurrentPropertyModal(),
    };
    this.cacheService.setDesignerOutputs(contx);
    this.ngxSmartModalService.getModal('goToNewPageModal').close();

    if (
      this.completeContext.listPath !== undefined &&
      this.completeContext.listPath !== ''
    ) {
      this.router.navigate(['../../', this.NewPageName], {
        relativeTo: this.activatedRoute,
      });
    } else {
      this.router.navigate(['../', this.NewPageName], {
        relativeTo: this.activatedRoute,
      });
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/modals/page-modal.component.ts